import React, { useState, useCallback } from "react";
import Template from "./Button.jsx";
import "./styles.styl";

const Button = (props) => {
  const [confirmActive, setConfirmActive] = useState(false);

  const onClick = useCallback(
    (e) => {
      const { onClick, confirm } = props;
      if (!confirm) {
        onClick && onClick(e);
      } else {
        setConfirmActive(true);
      }
    },
    [props],
  );

  const onConfirm = useCallback(() => {
    const { onClick } = props;
    onClick && onClick();
    setConfirmActive(false);
  }, [props]);

  const onAbort = useCallback(() => {
    setConfirmActive(false);
  }, []);

  const handlers = {
    onClick,
    onConfirm,
    onAbort,
  };

  return <Template {...props} confirmActive={confirmActive} {...handlers} />;
};

export default Button;
